import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5928467c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tit-box" }
const _hoisted_2 = { class: "img" }
const _hoisted_3 = { class: "rbox" }
const _hoisted_4 = { class: "txt-tit" }
const _hoisted_5 = { class: "descr" }
const _hoisted_6 = {
  key: 0,
  class: "status"
}
const _hoisted_7 = {
  key: 1,
  class: "status"
}
const _hoisted_8 = {
  key: 2,
  class: "status"
}
const _hoisted_9 = {
  key: 3,
  class: "status0"
}
const _hoisted_10 = { class: "text" }

import { Approve, approveStaff, staffItem } from '@/apis/base'
import { watch, ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  props: ['approve'],
  setup(__props) {

const props = __props


const approve = ref({} as Approve)

watch(props, (newValue, oldValue) => {
  // console.log('watch 已触发', newValue)
  approve.value = newValue.approve
})

return (_ctx: any,_cache: any) => {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_cell = _resolveComponent("van-cell")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_image, {
          round: "",
          width: "50",
          height: "50",
          src: approve.value.staff?.avatar
        }, null, 8, ["src"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_cell, { border: false }, {
          title: _withCtx(() => [
            _createElementVNode("span", _hoisted_4, _toDisplayString(approve.value.type_name), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, _toDisplayString(approve.value.staff?.name) + " " + _toDisplayString(approve.value.staff?.job_name), 1)
      ]),
      (approve.value.state === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_van_image, {
              width: "65",
              height: "65",
              src: require('@/assets/project/approve1.png')
            }, null, 8, ["src"])
          ]))
        : _createCommentVNode("", true),
      (approve.value.state === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_van_image, {
              width: "65",
              height: "65",
              src: require('@/assets/project/refuse2.png')
            }, null, 8, ["src"])
          ]))
        : _createCommentVNode("", true),
      (approve.value.state === 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_van_image, {
              width: "65",
              height: "65",
              src: require('@/assets/project/repeal3.png')
            }, null, 8, ["src"])
          ]))
        : _createCommentVNode("", true),
      (approve.value.state === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(approve.value.approve_staff.name) + "处理中", 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})